// extracted by mini-css-extract-plugin
export default {"back-to-top-button":"BackToTopButton-module--back-to-top-button--dYvDV"};